"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AP_SOUTHEAST_CODES = exports.EU_WEST_CODES = exports.EU_CENTRAL_CODES = exports.US_EAST_CODES = exports.CA_CENTRAL_CODES = exports.CA_CENTRAL = exports.AP_SOUTHEAST = exports.EU_WEST = exports.EU_CENTRAL = exports.US_EAST = void 0;

var _staging, _production;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var US_EAST = 'usEast';
exports.US_EAST = US_EAST;
var EU_CENTRAL = 'euCentral';
exports.EU_CENTRAL = EU_CENTRAL;
var EU_WEST = 'euWest';
exports.EU_WEST = EU_WEST;
var AP_SOUTHEAST = 'apSoutheast';
exports.AP_SOUTHEAST = AP_SOUTHEAST;
var CA_CENTRAL = 'caCentral';
exports.CA_CENTRAL = CA_CENTRAL;
var CA_CENTRAL_CODES = ['ca'];
exports.CA_CENTRAL_CODES = CA_CENTRAL_CODES;
var US_EAST_CODES = ['us'];
exports.US_EAST_CODES = US_EAST_CODES;
var EU_CENTRAL_CODES = ['eu', 'de', 'dk', 'fi', 'nl', 'no', 'se', 'xs', 'xd', 'xs2', 'xs3', 'xs4', 's1', 's2', 's3', 's4'];
exports.EU_CENTRAL_CODES = EU_CENTRAL_CODES;
var EU_WEST_CODES = ['gb', 'ie', 'fr'];
exports.EU_WEST_CODES = EU_WEST_CODES;
var AP_SOUTHEAST_CODES = ['au', 'rw'];
exports.AP_SOUTHEAST_CODES = AP_SOUTHEAST_CODES;
var cartApiData = {
  staging: (_staging = {}, _defineProperty(_staging, US_EAST, {
    url: 'https://uo5csdbgm5htlcz42uvuhkqjky.appsync-api.us-east-1.amazonaws.com/graphql',
    region: 'US-EAST-1',
    key: 'da2-pctymxjecjg2reobzc5ql6xixm'
  }), _defineProperty(_staging, EU_CENTRAL, {
    url: 'https://xsrvennvkzghxkoko4iytw4xmy.appsync-api.eu-central-1.amazonaws.com/graphql',
    region: 'EU-CENTRAL-1',
    key: 'da2-qmj7ik75brh5zo67t2glv4ibgy'
  }), _defineProperty(_staging, EU_WEST, {
    url: 'https://5sihtdtegfaltctzsru4cjquai.appsync-api.eu-west-2.amazonaws.com/graphql',
    region: 'EU-WEST-2',
    key: 'da2-6xcgqnir7re3da5s725pvs7vha'
  }), _defineProperty(_staging, AP_SOUTHEAST, {
    url: 'https://nmdihvyu6bgfdcdzjafpjcdk5a.appsync-api.ap-southeast-1.amazonaws.com/graphql',
    region: 'AP-SOUTHEAST-1',
    key: 'da2-76hxudglhzehdnuauajwequb2y'
  }), _defineProperty(_staging, CA_CENTRAL, {
    url: 'https://5vj66ylgebfqtp445u57iwuflq.appsync-api.ca-central-1.amazonaws.com/graphql',
    region: 'CA-CENTRAL-1',
    key: 'da2-bpoxg4kmc5cblel7jfyxtkgffu'
  }), _staging),
  production: (_production = {}, _defineProperty(_production, US_EAST, {
    url: 'https://smt653u5nnasfgp3feszgiix6q.appsync-api.us-east-1.amazonaws.com/graphql',
    region: 'US-EAST-1',
    key: 'da2-swth76hmezfhdldtqoubhsxbj4'
  }), _defineProperty(_production, EU_CENTRAL, {
    url: 'https://mz6tg3bxn5b6tgebjf3xkdenxm.appsync-api.eu-central-1.amazonaws.com/graphql',
    region: 'EU-CENTRAL-1',
    key: 'da2-4lmo6m5oozdmpblreikcqdg244'
  }), _defineProperty(_production, EU_WEST, {
    url: 'https://j4ibjiyzhnagdfjs56klrxfoli.appsync-api.eu-west-2.amazonaws.com/graphql',
    region: 'EU-WEST-2',
    key: 'da2-fpmw2u6oyvarho2dnzybbflyxi'
  }), _defineProperty(_production, AP_SOUTHEAST, {
    url: 'https://u4uxmrfn3rfi7okcpigad7qd5m.appsync-api.ap-southeast-1.amazonaws.com/graphql',
    region: 'AP-SOUTHEAST-1',
    key: 'da2-2nx3cunmjjg6flt4k4znmbfrn4'
  }), _defineProperty(_production, CA_CENTRAL, {
    url: 'https://qvp57nyyfbgarjvcxkouui63pu.appsync-api.ca-central-1.amazonaws.com/graphql',
    region: 'CA-CENTRAL-1',
    key: 'da2-l4zjatchxnhbloz2g4mohqi47u'
  }), _production),
  US_EAST: US_EAST,
  US_EAST_CODES: US_EAST_CODES,
  EU_CENTRAL: EU_CENTRAL,
  EU_CENTRAL_CODES: EU_CENTRAL_CODES,
  EU_WEST: EU_WEST,
  EU_WEST_CODES: EU_WEST_CODES,
  AP_SOUTHEAST: AP_SOUTHEAST,
  AP_SOUTHEAST_CODES: AP_SOUTHEAST_CODES,
  CA_CENTRAL: CA_CENTRAL,
  CA_CENTRAL_CODES: CA_CENTRAL_CODES
};
var _default = cartApiData;
exports["default"] = _default;